const env = process.env.NODE_ENV || 'development'; console.log('RUNNING ' + env)
const loadedModule = require('./config.' + env + '.js')
module.exports = loadedModule
